import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import { getNewSlugURL } from 'lib/utils/getNewSlugURL';

const useHandleDetectSlugsError = () => {
  const appNavigator = useAppNavigator();
  let errorSlug = false;
  const handleNoSlug = (slugs) => {
    slugs.forEach((slug) => {
      if (slug.resource_id === null || slug.slug_type === null) {
        errorSlug = true;
      }
    });
    return errorSlug;
  };

  const handleNewSlug = (slugs, path) => {
    const newPath = getNewSlugURL(slugs, path);
    if (newPath) {
      appNavigator.push(newPath);
    }
    return newPath;
  };
  return [handleNoSlug, handleNewSlug];
};
export default useHandleDetectSlugsError;
